module.exports = __webpack_public_path__ + "img/figuren.36a692d8.jpg";